<script>
import MasterDetail from "@/components/master-detail.vue";
import QueueDialog from "@/components/queue-dialog.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    MasterDetail,
    QueueDialog,
  },
  computed: {
    ...mapGetters(['clientId', 'anoBase', 'trimestre', 'selectedClient']),
    columns() {
      return [
        {
          key: "n",
          name: "Nº",
          align: 1,
        },
        {
          key: "incentivo",
          name: "Nome Incentivo"
        },
        {
          key: "valor_IRPJ",
          name: "Valor IRPJ",
        },
        {
          key: "valor_CSLL",
          name: "Valor CSLL",
        }
      ];
    },
    customResource: function() {
      const toCurrency = this.$options.filters.toCurrency;
      const setTrimestral = (value) => this.trimestral = value;
      const self = this;
      const resource = this.apiResource(`/v1/clientes/${self.clientId}/lalur`);
      
      return {
        async get({ query }) {                   
          const response = await resource.get({ query });

          const { trimestral, itens } = response ?? {};

          setTrimestral(!!trimestral);

          // Lucro Real Anual — valores do LALUR são acumulados; usa a última competência com valor em vez de somar
          const isAnual = self.selectedClient?.regime_tributario == 1;
          const getTotal = (campo) => {
            if (isAnual) {
              const comValor = (itens || [])
                .filter((item) => !!item[campo])
                .sort((a, b) => (a.competencia || "").localeCompare(b.competencia || ""));
              const ultimo = comValor[comValor.length - 1];
              return Number((ultimo ? ultimo[campo] : 0).toFixed(4));
            }

            return Number((itens?.reduce((sum, item) => sum + (item[campo] || 0), 0) || 0).toFixed(4));
          };

          const totalIrpj = getTotal("irpj");
          const totalCsll = getTotal("csll");

          return [
            "Dispêndios como Despesa Operacional",
            "Redução de 50% de IPI",
            "Depreciação Acelerada Integral no Ano de Aquisição",
            "Amortização Acelerada de Bens Intangíveis",
            "Universidades, Instituições de Pesquisa e Inventores Independentes",
            "Transferências a Micro e Pequenas Empresas",
            "Transferências a Inventor Independente",
            "Dispêndios - Adicional de 60 a 80%", // index === 7
            "Patentes e Cultivares - Adicional de 20%",
            "Instituições Científicas e Tecnológicas - ICT e Entidades Científicas e Tecnológicas Privadas, sem Fins Lucrativos",
            "Depreciação Acelerada Vinculada a Projetos",
            "Amortização Acelerada de Instalações Fixas",
            "Subvenções Governamentais da União",
            "Atividades de Informática e Automação"
          ].map((label, index) => ({
            n: 30 + index,
            incentivo: `INOVAÇÃO TECNOLÓGICA - ${label}`,
            valor_IRPJ: index === 7 ? toCurrency(totalIrpj) : "",
            valor_CSLL: index === 7 ? toCurrency(totalCsll) : ""
          }));
        }
      };
    },    
    isTrimestral: function() {
      // Use the local flag if it was set by the first response, otherwise use the client regime
      return this.trimestral || this.selectedClient?.regime_tributario == 2;
    },
    isReady: function() {
      // Ensure we have a valid clientId and the selectedClient object corresponds to it
      return !!this.clientId && this.selectedClient?.id === this.clientId;
    }
  },
  data: function() {
    return {
      opts: {},
      trimestral: this.$store.getters.selectedClient?.regime_tributario == 2,
      isVisibleQueueDialog: false,
    };
  },
  methods: {
    async doExport() {
      const response = await this.exportacaoAssincrona();
      if(response) {
        this.isVisibleQueueDialog = true;
      }
    },
    async exportacaoAssincrona() {
      const resource = this.apiResource(`v1/clientes/${this.clientId}/exportacao`);
      const dados = this.exportacaoData();
      return await resource.save({ ...dados });
    },
    exportacaoData() {      
      const [trimestreSelecionado = 1] = this.trimestre || [];

      return {
        tipoRelatorio: 'dirbi',
        trimestre: this.trimestral ? trimestreSelecionado : null,
        anoBase: this.anoBase
      }
    }
  }
};
</script>

<template>
  <!-- TODO caso seja necessárioinserir a segunda linha de cabeçalho indicando o trimestre ou "Somatório do Ano" provavelmente deve trocar MasterDetail por v-data-table -->
  <MasterDetail
    v-if="isReady"
    :key="`${clientId}-${isTrimestral}`"
    class="master-detail"
    :cols="columns"
    :customResource="customResource"
    disableContextMenu
    disablePagination
    :opts="opts"
    :hasOneQuarterFilter="isTrimestral"
    :hasYearFilter="!isTrimestral"
    hasBeneficioFilter
    :canDelete="false"
    :canEdit="false"
    :hasExportCSV="false"
    :hasNewButton="false"    
  >
    <div class="table-v-action-button"
      @click="doExport"
    >
      <v-icon class="mr-1">mdi-file-delimited-outline</v-icon> 
      Exportação assíncrona
    </div>

    <QueueDialog
      appendIcon="mdi-file-delimited-outline"
      title="Exportação assíncrona - Dirbi"
      :opened.sync="isVisibleQueueDialog"
    >      
    </QueueDialog>
  </MasterDetail>
</template>

<style lang="scss" scoped>
.master-detail {
  &,
  &::v-deep .v-data-table__wrapper {
    height: 100% !important;
  }

  // Benefício e ano-base primeiro na barra, como na DIRBI de Lei de Informática
  &::v-deep .filtroBeneficio {
    order: -2;
  }

  &::v-deep .filtroAno,
  &::v-deep [aria-label="trimestreAno"] {
    order: -1;
  }
}
</style>
